import React from 'react';
import Styles from "./Button.module.css"
import "../UI/public.css";

const Button = (props) => {

  return (
    <button
      disabled={props.disabled !== undefined ? props.disabled : undefined}
      style={props.style}
      onChange={props.onChange !== undefined ? props.onChange : undefined}
      onClick={props.onClick !== undefined ? props.onClick : undefined}
      className={
        props.className !== undefined ?
          props.color !== undefined ?
            props.className + " " + props.color + " " + Styles.default_btn_style
            :
            props.className + " greenBtn " + Styles.default_btn_style // green is default style
          :
          props.color !== undefined ?
            props.color + " " + Styles.default_btn_style
            :
            " greenBtn " + Styles.default_btn_style // green is default style
      }
      type={props.type !== undefined ? props.type : undefined}

    >
      {props.children}
    </button>
  )

};

export default Button;
